import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Acao } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class AcaoService extends BaseResourceService<Acao> {

  constructor(
    protected injector: Injector
  ) {
    super(`acoes`, injector);
  }

}
